import React, { useState, useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { GET_ME, UPDATE_USER } from '../graphql/queries';
import LoadingSpinner from './LoadingSpinner';
import ErrorMessage from './ErrorMessage';
import './MyPage.css';

const MyPage = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const { loading, error, data } = useQuery(GET_ME, { skip: !token });
  const [updateUser, { loading: saving }] = useMutation(UPDATE_USER);

  const [form, setForm] = useState({ screenName: '', name: '' });
  const [serverErrors, setServerErrors] = useState([]);
  const [saved, setSaved] = useState(false);

  const user = data?.me;

  useEffect(() => {
    if (user) {
      setForm({ screenName: user.screenName || '', name: user.name || '' });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setSaved(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerErrors([]);
    setSaved(false);

    const { data: result } = await updateUser({
      variables: { input: { screenName: form.screenName, name: form.name } },
    });

    const payload = result?.updateUser;
    if (payload?.errors?.length > 0) {
      setServerErrors(payload.errors);
    } else {
      setSaved(true);
    }
  };

  if (!token) {
    return (
      <div className="mypage">
        <div className="mypage-header">
          <button className="back-button" onClick={() => navigate('/')}>
            ← 一覧に戻る
          </button>
          <h1>マイページ</h1>
        </div>
        <ErrorMessage error={{ message: 'ログインが必要です' }} />
      </div>
    );
  }

  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorMessage error={error} />;

  return (
    <div className="mypage">
      <div className="mypage-header">
        <button className="back-button" onClick={() => navigate('/')}>
          ← 一覧に戻る
        </button>
        <h1>マイページ</h1>
      </div>

      <div className="mypage-card">
        <h2 className="mypage-section-title">ユーザー情報</h2>
        <div className="mypage-details">
          <div className="detail-row">
            <span className="detail-label">メールアドレス</span>
            <span className="detail-value">{user?.email || '-'}</span>
          </div>
        </div>
      </div>

      <div className="mypage-card">
        <h2 className="mypage-section-title">プロフィール編集</h2>
        <form className="mypage-form" onSubmit={handleSubmit}>
          <div className="mypage-form-row">
            <label className="mypage-form-label" htmlFor="screenName">
              表示名
            </label>
            <input
              id="screenName"
              className="mypage-form-input"
              type="text"
              name="screenName"
              value={form.screenName}
              onChange={handleChange}
            />
          </div>
          <div className="mypage-form-row">
            <label className="mypage-form-label" htmlFor="name">
              名前
            </label>
            <input
              id="name"
              className="mypage-form-input"
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
            />
          </div>
          {serverErrors.length > 0 && (
            <ul className="mypage-errors">
              {serverErrors.map((err, i) => (
                <li key={i}>{err}</li>
              ))}
            </ul>
          )}
          {saved && <p className="mypage-saved">保存しました</p>}
          <div className="mypage-form-actions">
            <button className="mypage-submit" type="submit" disabled={saving}>
              {saving ? '保存中...' : '保存'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MyPage;
